<div class="container" cdkScrollable>
  <form class="form-container" [formGroup]="newsForm">
    <div class="left-side">
      <mat-form-field appearance="outline" class="input-form">
        <mat-label>Titulo</mat-label>
        <input matInput formControlName="title" />
        <mat-error *ngIf="newsForm.get('title')?.hasError('required')"
          >Informe o titulo</mat-error
        >
      </mat-form-field>

      <quill-editor
        formControlName="description"
        placeholder="Mensagem"
        classes="editor-text-area"
        [modules]="customModules"
        (onEditorCreated)="addBindingCreated($event)"
      >
        <div quill-editor-toolbar>
          <span class="ql-formats">
            <button class="ql-bold" matTooltip="Negrito (Ctrl+B)"></button>
            <button class="ql-italic" matTooltip="Itálico (Ctrl+I)"></button>
            <button
              class="ql-underline"
              matTooltip="Sublinhar (Ctrl+U)"
            ></button>
          </span>
          <span class="ql-formats">
            <select class="ql-align">
              <option selected></option>
              <option value="center"></option>
              <option value="right"></option>
              <option value="justify"></option>
            </select>
            <button
              class="ql-list"
              value="ordered"
              matTooltip="Lista numerada (Ctrl + Shift + 7)"
            ></button>
            <button
              class="ql-list"
              value="bullet"
              matTooltip="Lista com marcadores (Ctrl + Shift +8)"
            ></button>
          </span>
          <span class="ql-formats">
            <button class="ql-clean" matTooltip="Remover formatação"></button>
          </span>
        </div>
      </quill-editor>
      <div class="custom-error-wrapper">
        <mat-error
          *ngIf="
            newsForm.dirty && newsForm.get('description')?.hasError('required')
          "
          >Informe o texto</mat-error
        >
      </div>

      <div class="attachments">
        <div class="title">
          <span> Anexos (Opcional) </span>
          <mat-icon
            svgIcon="icon-doubt"
            #attachmentTooltip="matTooltip"
            (click)="attachmentTooltip.show()"
            matTooltip="Extensões permitidas: jpg, png e pdf.

              Tamanho máximo recomendado de cada anexo: 10MB."
          ></mat-icon>
        </div>
        <div class="list">
          <app-file-uploaded-list
            *appIfRoles="profilesElegibleToManageNews"
            [type]="'attachment'"
            [initialFiles]="attachments"
            [filePathOldStructure]="attachmentsPath"
            (currentFilesEmitter)="onCurrentAttachmentsEmit($event)"
            (filesToDeleteEmitter)="onAttachmentsToDeleteEmit($event)"
          >
          </app-file-uploaded-list>
        </div>
      </div>
    </div>

    <div class="right-side">
      <p class="title">Para</p>
      <div class="select-profile-input">
        <mat-form-field
          appearance="outline"
          class="pointer-cursor"
          (click)="openList($event, triggerProfiles)"
        >
          <mat-label>Perfil</mat-label>
          <input
            #triggerProfiles="matAutocompleteTrigger"
            type="text"
            [matAutocomplete]="autoProfiles"
            matInput
            formControlName="profiles"
            readonly
            class="pointer-cursor"
          />
          <mat-error *ngIf="newsForm.get('profiles')?.hasError('required')"
            >Selecione um pefil</mat-error
          >
          <mat-autocomplete #autoProfiles="matAutocomplete">
            <mat-option [style.display]="'none'"></mat-option>
            <app-profile-simple-list
              [selectAllText]="profilesSelectAllText"
              [initialIdProfiles]="selectedIdsProfiles"
              (selectEvent)="handleProfileSelect($event)"
              [hidePhoto]="true"
              [excludeProfiles]="excludeProfiles"
              [hideButtons]="true"
            >
            </app-profile-simple-list>
          </mat-autocomplete>

          <span matSuffix class="material-icons" *ngIf="!autoProfiles.isOpen">
            expand_more
          </span>

          <span matSuffix class="material-icons" *ngIf="autoProfiles.isOpen">
            expand_less
          </span>
        </mat-form-field>
      </div>

      <div class="year-classrooms">
        <div class="year" *ngIf="startTxtYear">
          <app-school-year-combo
            class="year"
            [txtYear]="startTxtYear"
            (yearSelected)="getYearSelected($event)"
          >
          </app-school-year-combo>
        </div>

        <div class="classrooms">
          <mat-form-field
            appearance="outline"
            class="pointer-cursor"
            (click)="hasClassrooms && openList($event, triggerClassroom)"
          >
            <mat-label>Turmas</mat-label>
            <input
              #triggerClassroom="matAutocompleteTrigger"
              type="text"
              matInput
              formControlName="classrooms"
              [matAutocomplete]="autoClassroom"
              readonly
              class="pointer-cursor"
            />
            <mat-autocomplete #autoClassroom="matAutocomplete">
              <mat-option [style.display]="'none'"></mat-option>
              <app-select-hierarquical-list
                *ngIf="segmentTreeData.length > 0"
                [treeData]="segmentTreeData"
                [initialSelection]="selectedIdsClassrooms"
                (selectEvent)="handleSelectClassroom($event)"
                [hideButtons]="true"
              >
              </app-select-hierarquical-list>
            </mat-autocomplete>
            <mat-error *ngIf="newsForm.get('classrooms')?.hasError('required')">
              Selecione uma Turma
            </mat-error>

            <span
              matSuffix
              class="material-icons"
              *ngIf="hasClassrooms && !autoClassroom.isOpen"
            >
              expand_more
            </span>

            <span matSuffix class="material-icons" *ngIf="hasClassrooms && autoClassroom.isOpen">
              expand_less
            </span>
          </mat-form-field>
        </div>
      </div>

      <app-attention-alert
        *ngIf="!hasClassrooms"
        [message]="alertMessage"
      >
      </app-attention-alert>

      <div class="authorization">
        <mat-slide-toggle
          [checked]="isAuthorizationOn"
          (change)="onAuthorizationChange()"
        >
        </mat-slide-toggle>
        <div class="authorization-text">Solicitar autorização (Opcional)</div>
        <mat-icon
          svgIcon="icon-doubt"
          #authorizationTooltip="matTooltip"
          (click)="authorizationTooltip.show()"
          matTooltip="Ative esta opção caso deseje que os responsáveis respondam SIM ou NÃO.

            Em seguida, determine um prazo, indicando até quando os responsáveis poderão responder."
        ></mat-icon>
      </div>
      <div *ngIf="isAuthorizationOn">
        Prazo para respostas
        <div class="date-time">
          <mat-form-field appearance="outline" class="input-form date">
            <mat-label>Data</mat-label>
            <input
              matInput
              readonly
              [matDatepicker]="authorizationLimitPicker"
              formControlName="authorizationLimitDate"
              (focus)="authorizationLimitPicker.open()"
              [min]="minDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="authorizationLimitPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #authorizationLimitPicker></mat-datepicker>
            <mat-error
              *ngIf="newsForm.get('authorizationLimitDate')?.hasError('msg')"
            >
              {{ newsForm.get("authorizationLimitDate")?.errors?.msg }}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-form hour">
            <mat-label>Hora</mat-label>
            <input
              matInput
              formControlName="authorizationLimitTime"
              type="time"
            />
            <mat-error
              *ngIf="newsForm.get('authorizationLimitTime')?.hasError('msg')"
            >
              {{ newsForm.get("authorizationLimitTime")?.errors?.msg }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="background-selector">
        <div class="title">
          <div>Capa da notícia (Opcional)</div>
          <mat-icon
            svgIcon="icon-doubt"
            #backgroundTooltip="matTooltip"
            (click)="backgroundTooltip.show()"
            matTooltip="Dimensão recomendada de capa: 450px de largura por 150px de altura.

              Tamanho máximo permitido da imagem: 10MB."
          ></mat-icon>
        </div>
        <app-file-uploaded-list
          *appIfRoles="profilesElegibleToManageNews"
          [type]="'background'"
          [initialFiles]="bgFiles"
          [filePathOldStructure]="backgroundFilePath"
          (currentFilesEmitter)="onCurrentBackgroundFileEmit($event)"
          (filesToDeleteEmitter)="onBackgroundFileToDeleteEmit($event)"
        >
        </app-file-uploaded-list>
      </div>
      <p class="title">Programar publicação (Opcional)</p>
      <div class="date-time">
        <mat-form-field appearance="outline" class="input-form date">
          <mat-label>Data</mat-label>
          <input
            matInput
            readonly
            [matDatepicker]="picker"
            formControlName="releaseDate"
            (focus)="picker.open()"
            [min]="minDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="newsForm.get('releaseDate')?.hasError('dates')"
            >Data de agendamento deve ser maior que a atual</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-form hour">
          <mat-label>Hora</mat-label>
          <input matInput formControlName="releaseTime" type="time" />
          <mat-error *ngIf="newsForm.get('releaseTime')?.hasError('time')"
            >Precisa ser programada em hora futura</mat-error
          >
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
<div
  class="footer-buttons"
  *appIfRoles="profilesElegibleToManageNews"
>
  <div class="flex-btn">
    <app-button-spinner
      buttonText="Cancelar"
      (buttonClicked)="onCancelClicked()"
      color="white"
      [disabled]="saveInProgress"
    >
    </app-button-spinner>
    <app-button-spinner
      class="save-button"
      buttonText="{{ saveButtonText }}"
      [inProgressText]="inProgressText"
      [inProgress]="saveInProgress"
      (buttonClicked)="handleSaveButtonClicked()"
      color="blue"
      [disabled]="!newsForm.valid || !newsForm.dirty || !hasClassrooms"
    >
    </app-button-spinner>
  </div>
</div>
